import { useAsyncData, useRoute, useRuntimeConfig } from '#imports'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { insertIf } from '@backmarket/utils/collection/insertIf'

import type { GetReviewCollectionResponse } from '~/api/reviews/types/GetReviewCollectionResponse'

function removeUploadPicturesStep(
  apiData: GetReviewCollectionResponse,
): GetReviewCollectionResponse {
  const { steps } = apiData

  const stepsWithoutAttachments = steps.filter(
    (step) => step.identifier !== 'attachments',
  )

  return {
    ...apiData,
    steps: stepsWithoutAttachments,
  }
}

export function useGetOrderReviewCollection() {
  const $httpFetch = useHttpFetch()
  const { params, query } = useRoute()
  const salesOrderItemUuid = params.orderlineId.toString()
  const { market } = useMarketplace()
  const { FF_REVIEW_COLLECT_ENABLE_UPLOAD_PICTURES_STEP_COUNTRIES = '' } =
    useRuntimeConfig().public

  const shouldSkipUploadPicturesStep =
    !FF_REVIEW_COLLECT_ENABLE_UPLOAD_PICTURES_STEP_COUNTRIES.includes(
      market.countryCode,
    )

  const getReviewCollectionPromise = useAsyncData(
    () => {
      return $httpFetch(
        '/reviews/v2/sales-order-item/:salesOrderItemUuid/review-collection',
        {
          method: 'GET',
          pathParams: {
            salesOrderItemUuid,
          },
          query: {
            ...insertIf(!!query?.authToken, { authToken: query.authToken }),
            ...insertIf(!!query?.source, { source: query.source }),
          },
        },
      )
    },
    {
      ...insertIf(shouldSkipUploadPicturesStep, {
        transform: removeUploadPicturesStep,
      }),
    },
  )

  const { data, error } = getReviewCollectionPromise

  return { data, error, getReviewCollectionPromise }
}
